import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzSubmenuNoneInlineChildComponent } from "ng-zorro-antd/menu";
import { UiMenuModeType, UiMenuThemeType } from "../../menu.models";

@Component({
  selector: "[ui-submenu-none-inline-child]",
  exportAs: "uiSubmenuNoneInlineChild",
  templateUrl: "./submenu-non-inline-child.component.html",
})
export class UiSubmenuNoneInlineChildComponent extends NzSubmenuNoneInlineChildComponent {
  @Input() public menuClass = "";
  @Input() public theme: UiMenuThemeType = "light";
  @Input() public templateOutlet: TemplateRef<NzSafeAny> | null = null;
  @Input() public isMenuInsideDropDown = false;
  @Input() public mode: UiMenuModeType = "vertical";
  @Input() public position = "right";
  @Input() public nzDisabled = false;
  @Input() public nzOpen = false;
  @Output() public readonly subMenuMouseState = new EventEmitter<boolean>();
}
